import React from 'react'
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import Chip from "@material-ui/core/Chip";
import './LayoutObject.css';

/*  A from/to date-range filter pair that shows clickable year shortcuts inside each
    calendar popup (same UI as Layout.yearPresets used by TransactionsTable).
    Clicking a year sets the from-date to Jan 1 and the to-date to Dec 31 of that year,
    then closes the popup. The two updates are dispatched on separate ticks (the to-date
    on a microtask) so parents that read-and-rewrite a filtersMap object in handleDateChange
    don't lose the from-date update to React's batched setState. */
const YearPresetRangeDatePickers = ({
    fromValue,
    toValue,
    fromLabel = 'From',
    toLabel = 'To',
    format = 'yyyy-MM-dd',
    width = 350,
    pickerStyle = {},
    earliestYear = 2023,
    onFromChange,
    onToChange,
}) => {
    const [fromOpen, setFromOpen] = React.useState(false)
    const [toOpen, setToOpen] = React.useState(false)

    const currentYear = new Date().getFullYear()
    const years = []
    for (let year = currentYear; year >= earliestYear; year--) {
        years.push(year)
    }

    const handleYearClick = (year) => {
        // From the first day of the year; let the to-date keep the dialog's own
        // end-of-day convention by routing it through onToChange (same as a manual pick).
        onFromChange(new Date(year, 0, 1))
        Promise.resolve().then(() => onToChange(new Date(year, 11, 31)))
        setFromOpen(false)
        setToOpen(false)
    }

    const YearPresetToolbar = () => (
        <div className='year-preset-toolbar'>
            <div className='year-preset-toolbar-chips'>
                {years.map((year) => (
                    <Chip
                        key={year}
                        label={year}
                        size="small"
                        clickable
                        variant="outlined"
                        style={{borderColor: "#acd685", margin: "1px 6px 1px 0", fontSize: "12px", flexShrink: 0}}
                        onClick={() => handleYearClick(year)}
                    />
                ))}
            </div>
        </div>
    )

    const baseStyle = { width, marginBottom: 20, ...pickerStyle }

    const handleChange = (dateInput, cb) => {
        let date = new Date(dateInput?.toString())
        if (date.toString() === "Invalid Date") {
            return
        }
        cb(date)
    }

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
                autoOk
                name="fromDate"
                variant="inline"
                inputVariant="outlined"
                label={fromLabel}
                format={format}
                style={baseStyle}
                value={fromValue}
                InputAdornmentProps={{ position: "start" }}
                open={fromOpen}
                onOpen={() => setFromOpen(true)}
                onClose={() => setFromOpen(false)}
                ToolbarComponent={YearPresetToolbar}
                onChange={dateInput => handleChange(dateInput, onFromChange)}
            />
            <KeyboardDatePicker
                autoOk
                name="toDate"
                variant="inline"
                inputVariant="outlined"
                label={toLabel}
                format={format}
                style={baseStyle}
                value={toValue}
                InputAdornmentProps={{ position: "start" }}
                open={toOpen}
                onOpen={() => setToOpen(true)}
                onClose={() => setToOpen(false)}
                ToolbarComponent={YearPresetToolbar}
                onChange={dateInput => handleChange(dateInput, onToChange)}
            />
        </MuiPickersUtilsProvider>
    )
}

export default YearPresetRangeDatePickers
